import React from 'react';

import DonationDeleteForm from '@/core/components/forms/DonationDeleteForm';
import Icons from '@/core/components/Icons';
import Modal from '@/core/components/Modal';
import Store from '@/core/lib/new-architecture/store';
import { useTranslationContext } from '@/core/lib/translation/translation.context';
import { DonationDeleteReason } from '@/core/types/donation';

export interface DonationDeleteModalProps {
  isOpen: boolean;
  closeModal: () => void;
  donationId: number;
}

const DonationDeleteModal: React.FC<DonationDeleteModalProps> = ({ isOpen, closeModal, donationId }) => {
  const { t } = useTranslationContext(['common', 'profile.donations']);

  const { data: takers, isLoading } = Store.donation.useTakers(donationId);

  const potentialTakers = takers?.getTakers();

  const deleteDonationReasons =
    potentialTakers && potentialTakers.length > 0
      ? [
          { id: DonationDeleteReason.GIVE_DONNONS, label: `${t('components.donation.delete.reasons.give_donnons', { ns: 'common' })}` },
          { id: DonationDeleteReason.GIVE_ELSE, label: `${t('components.donation.delete.reasons.give_else', { ns: 'common' })}` },
          { id: DonationDeleteReason.NOT_INTERESTED, label: `${t('components.donation.delete.reasons.not_interested', { ns: 'common' })}` },
          { id: DonationDeleteReason.CHANGED_MIND, label: `${t('components.donation.delete.reasons.changed_mind', { ns: 'common' })}` },
          { id: DonationDeleteReason.SELL_ELSE, label: `${t('components.donation.delete.reasons.sell_else', { ns: 'common' })}` },
        ]
      : [
          { id: DonationDeleteReason.GIVE_ELSE, label: `${t('components.donation.delete.reasons.give_else', { ns: 'common' })}` },
          { id: DonationDeleteReason.NOT_INTERESTED, label: `${t('components.donation.delete.reasons.not_interested', { ns: 'common' })}` },
          { id: DonationDeleteReason.CHANGED_MIND, label: `${t('components.donation.delete.reasons.changed_mind', { ns: 'common' })}` },
          { id: DonationDeleteReason.SELL_ELSE, label: `${t('components.donation.delete.reasons.sell_else', { ns: 'common' })}` },
        ];

  return (
    <Modal isOpen={isOpen} onClose={closeModal}>
      {isLoading && (
        <div aria-label={t('spinner.aria-valuetext', { ns: 'profile.donations' })} className="flex h-screen items-center justify-center">
          <Icons icon="spinner" size="40" color="button-default" />
        </div>
      )}
      <DonationDeleteForm donationId={donationId} options={deleteDonationReasons} takers={potentialTakers} onClose={closeModal} />
    </Modal>
  );
};

export default DonationDeleteModal;
